<template>
  <div style="width: 94vw;height: 90vh;overflow: hidden;padding:3vh 3vw">
    <div class="flex justify-between" >
    <div style="width: 22%">
      <div style="background:rgb(255,255,200);padding:.3vw">
        <h2 class="h title">第一步：点击下方图标插入参考图</h2>
        <div class="desc " style="font-size: .8vw;color:red;text-align: center;">本平台适用于写实造型<br/>复杂场景需拆分出图效果更佳</div>
      </div>
      <!-- <h3 class="h title">插入参考图</h3>
      <div class="desc sec-tit">
        参考图支持线稿和写实风格，请根据需要选择对应选项
      </div> -->
      <div style="font-size: 0.8vw;line-height: 1.2vw;">
          <div>仅支持jpg、png格式，最大分辨率低于3000</div>
          <div>如上传出错请检查格式，</div>
          <div style="color:red">敏感政治人物，地标及成人主题无法出图</div>
      </div>
      <!-- <div style="margin-top: 20px">
        <el-radio v-model="radio" label="line" border>线稿图</el-radio>
        <el-radio v-model="radio" label="real" border>写实图</el-radio>
      </div> -->
      <div class="uploader flex" style="margin: .1vw 0; margin-top: .2vw;justify-content: center;">
        <uploader-component
          :value="url"
          action="/api/upload"
          @onChangeSuccesss="onChangeSuccesss2"
          name="image"
        >
        </uploader-component>
      </div>
      <!-- <div class="desc sec-tit" style="margin-top: 0px">
        单选项，只能选择一种上传参考图
      </div> -->
      <div style="height: 2px; background: #ddd; margin: 0.5vw 0"></div>

      <h3 class="h title" style="background:rgb(255,255,200);padding:.3vw">第二步：deepseek自动反推描述词</h3>
      <!-- <div class="desc sec-tit">
        大模型后台计算出图需要等待60-90秒，热门时段需等待更长时间
      </div> -->
      <!-- class="gray-container"  -->
      <div style="margin-bottom: .2vw;font-size: 0.8vw;line-height: 1.2vw;">
        <!-- <div class="h">平台已接入人工智能反推</div> -->
        <div class="desc" style="color: #000">
          上传图形后文本信息自动输入，如有偏差请手动修改
        </div>
        <div class="desc" style="color: red">
          禁颜色描述词，比如“红色衬衫“请改为”衬衫”
        </div>

        <el-input
          :rows="5"
          type="textarea"
          placeholder="请输入关键词"
          v-model="textarea"
          resize="none"
        >
        </el-input>
      </div>
      <h3 class="h title" style="background:rgb(255,255,200);padding:.3vw">第三步：</h3>
      <div style="display: flex;justify-content: center;">
        <el-button type="primary" @click="createTask" style="margin:1vw auto;line-height: 44px;width: 15vw; font-size: 1.5vw;">点击生图</el-button>

      </div>
      <!-- <div
        @click="createTask"
        class="btn"
        style="
          margin:1vw auto;
          line-height: 44px;
          color: #fff;
          width: 15vw;
          text-align: center;
          
          padding: 8px 0;
          font-size: 1.5vw;
          border-radius: 6px;
        "
      >
        点击生图
      </div> -->

      <div  style="font-size: 1vw;">
        调用FP16精度推理计算，出图需要等待最少90秒 <br>
        热门时段需要等待更长时间<br>
        若出现排队提示请稍等几分钟重新尝试
      </div>

    </div>

    <div style="width:62%;border: solid 2px #CCC;height:92.5vh">
      <div v-if="base64 == ''" style="padding:3vw 0;text-align: center;">
        <div style="font-weight: bold;font-size: 1.3vw;">出图成功后此处呈现标清3D预览<br>
          下载格式为高清PNG格式灰度图<br>
          需自行转换为浮雕模型
        </div>
        <div style="margin-top: 3vw;font-size: 1vw;">本平台模型训练数据精选自北斗星20年制图模型库<br>在细节处理手法上有独特的表现形式，尤其是写实人像、毛发、树木、山石、建筑等</div>
      </div>
      <!-- https://ai.bdxfd.com/storage/outputs/455e4967cc373cc34fd42ed68f181f9c.png -->
      <iframe :src="'https://ai.bdxfd.com/3DV2/index.html?src='+thumburl3D" style="width: 100%;height:100%" v-else>

      </iframe>
    </div>
    <div style="width: 16%;height: 94vh;display: flex; flex-direction: column;justify-content: space-between;">
      <div>
      <div
        style="
         width: 8vw;
         height: 8vw;
         margin: 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border: solid 1px #ccc;
          color: ccc;
          font-size: .9vw;
          text-align: center;
        "
        v-if="base64 == ''"
      >
        <div>图片生成完毕后<br/>将显示预览</div>
      </div>
      <!-- <div v-show="thumburl != ''"  :style="{
        width:picWidth+'px',
        height:picHeight+'px'
      }">
        <canvas id="canvas" style="width:100%;height:100%"/>

      </div> -->
      <img  v-else :src="base64"  style="display:block;width:10vw;margin:0 auto" draggable="false"/>
      <!-- <img id="image1" :src="thumburl" crossOrigin="anonymous"  v-if="thumburl != ''" style="display: none;"/>  -->
      <div style="text-align: center;margin:10px 0;font-size: .9vw;">扫码付费下载无水印高清图</div>
      <div class="gray-container" style="padding:1vw">

      <!-- <h3
        class="h title"
        style="font-size: 1.3vw; margin: 10px 0; text-align: center"
      >
        扫码付费下载高清图
      </h3> -->
      <!-- <div style="margin: 10px auto; display: flex; justify-content: center">
        <el-button type="primary" plain @click="go3D" v-if="thumburl != ''"
          >3D预览</el-button
        >
      </div> -->
      <div class="flex" style="justify-content: center">
        <div class="tag" style="border: none; margin: 0 auto;font-size:.9vw">
          您当前处于优惠期间
        </div>
      </div>
      <!-- <h3 class="h title">出图预览</h3>
      <div class="desc sec-tit">出图需要极大的算力支持</div>
      <div class="desc sec-tit">
        本流程使用顶级的大模型+北斗星专用数据库出图
      </div> -->
     
    
      <div
        style="
          width: 8vw;
          height: 8vw;
          margin: 0 auto;
          margin-top: 8px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          color: ccc;
          font-size: .9vw;
          text-align: center;
          border: solid 1px #ccc;
        "
        v-if="qrcode == ''"
      >
        <div>请先进行图片生成</div>
      </div>
      <img
        style="
          width: 8vw;
          height: 8vw;
          display: block;
          margin: 0 auto;
          margin-top: 8px;
        "
        v-else
        :src="qrcode"
      />

      <h3
        class="h title"
        style="font-size: 1vw; margin: 10px 0; text-align: center"
      >
        微信支付：10元
      </h3>
      <h3
        class="h title"
        style="font-size: 1vw; margin: 10px 0; text-align: center"
      >
        付款成功后自动下载
      </h3>
      <h3
        class="h title"
        style="
          font-size: 1vw;
          margin: 10px 0;
          margin-top: 10px;
          text-align: center;
          color: red;
        "
      >
        确认效果后再支付
      </h3>
      <h3
        class="h title"
        style="font-size: 1vw; margin: 10px 0; text-align: center; color: red"
      >
        一经支付
      </h3>
      <h3
        class="h title"
        style="font-size: 1vw; margin: 10px 0; text-align: center; color: red"
      >
        概不退款
      </h3>
    </div>
    </div>
    <div style="color:red;border:solid 1px red;padding:.5vw;width:14vw;line-height: 1.4vw;font-size:.8vw;margin-bottom:10px;">
      <span style="font-weight: bold;">北斗星灰度图增强器-免费版</span><br />

      <span style="font-weight: bold;">网盘下载链接</span><br />

      <div><a href="https://pan.baidu.com/s/197HO7KAb3lxiCi-S_b98yA?pwd=bdx9" target="_blank" style="font-size:.8rem">https://pan.baidu.com/s/197HO7KAb3lxiCi-S_b98yA?pwd=bdx9</a></div>
      ArtForm及SurfMill转浮雕提升巨大<br />

      Jdpaint版本依然有强大的增强效果

    </div>
    </div>
    
  </div>

      <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      >
      <span style="color:red">当前图像中有大量空白区域，建议裁剪后再出图，否则严重影响出图效果</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="subCreate">不裁剪，继续生图</el-button>
        <el-button type="primary" @click="unCreate">重新上传图像</el-button>
      </span>
    </el-dialog>
  </div>
  
</template>

<script>
import uploaderComponent from "@/components/uploader.vue";
import axios from "axios";
import { Loading } from "element-ui";
const instance = axios.create({
  headers: {
    uuid: localStorage.getItem("uuid"),
  },
});
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
export default {
  components: {
    uploaderComponent,
  },
  data() {
    return {
      dialogVisible:false,
      textarea: "",
      text_source:"",
      radio: "line",
      url: "",
      thumburl: "",
      timer: null,
      qrcode: "",
      timer2: null,
      startTimer: {
        status: 0,
        pay: 0,
      },
      base64:'',

    };
  },
  mounted() {
    // document.addEventListener('keydown',function(event){
    //   return 123 != event.keyCode || (event.returnValue = false)
    // })
    document.addEventListener('contextmenu',function(event){
      return event.returnValue = false  
    })
    // console.log(v4())
    if (!localStorage.getItem("uuid") || localStorage.getItem("uuid") == null) {
      localStorage.setItem(
        "uuid",
        S4() +
          S4() +
          "-" +
          S4() +
          "-" +
          S4() +
          "-" +
          S4() +
          "-" +
          S4() +
          S4() +
          S4()
      );
    }
    // this.base64ToCanvas()
  },
  watch:{
    thumburl(n,o){
      // if(n != '') this.base64ToCanvas()
    }
  },
  methods: {
   unCreate(){
    this.dialogVisible = false
    this.textarea = ''
    this.text_source = ''
    this.url = ''
   },
   subCreate(){
    let that = this
    this.dialogVisible = false
    instance
        .post("/api/create", {
          text: this.textarea,
          image: this.url,
          type: this.radio,
        })
        .then((res) => {
          if (res.data.error != 0) {
            that.$alert(res.data.msg, "错误", {
              confirmButtonText: "确定",
            });
          } else {

            that.getStatus(res.data.orderid);
          }
          // console.log(res.data.orderid)
        });
   },
    base64ToCanvas(){
     
    },
    go3D() {
      window.open("https://ai.bdxfd.com/3D/index.html?src=" + this.thumburl);
    },
    async downloadFile(url) {
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.src = url;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        canvas.toBlob((blob) => {
          const url1 = URL.createObjectURL(blob);
          const eleLink = document.createElement("a");
          eleLink.download = "图片";
          eleLink.href = url1;
          eleLink.click();
          eleLink.remove();
          // 用完释放URL对象
          URL.revokeObjectURL(url);
        });
      };
    },
    onChangeSuccesss2(e) {
      this.url = e.url;
      this.text_source = e.text+''
      this.textarea = e.text.replace('当前图像中有大量空白区域，建议裁剪后再出图，否则严重影响出图效果。','')

      // console.log(e)
    },
    handleRemove(file) {
      console.log(file);
    },
    async getPayStatusCheck(orderid) {
      if (this.startTimer.pay == 0) {
        //记录当前时间戳
        this.startTimer.pay = Date.now();
      }
      //比对时间
      let current = Date.now();
      if (current - this.startTimer.pay >= 360000) {
        this.$alert("支付超时，请重新生成", "错误", {
          confirmButtonText: "确定",
        });
        this.startTimer.pay = 0;
        this.thumburl = "";
        this.base64 = ''
        this.qrcode = "";
        clearTimeout(this.timer2);
        clearTimeout(this.timer);
        return;
      }

      //开启支付状态检测
      let that = this;
      if (that.timer2 != null) await clearTimeout(that.timer2);

      instance
        .post("/api/paystatus", {
          orderid,
        })
        .then(async (res) => {
          if (res.data.paystatus != 1) {
            that.timer2 = setTimeout(async () => {
              await that.getPayStatusCheck(orderid);
            }, 5000);
          } else {
            await that.downloadFile(res.data.download_url);
            //清理缩略图/描述/二维码/定时器
            // that.url = ''
            that.thumburl = "";
            that.base64 = "";
            that.qrcode = "";
            clearTimeout(that.timer2);
            clearTimeout(that.timer);
          }
        });
    },
    getQrcode(orderid) {
      instance
        .post("/api/getqrcode", {
          orderid,
        })
        .then((res) => {
          this.qrcode = res.data.qrcodeurl;
          this.getPayStatusCheck(orderid);
        });
    },
    async getStatus(orderid) {
      let that = this;
      const loadingIns = Loading.service({
        text: "生图至少需要90秒，若长时间未生成，请刷新后稍等重试。付款码有效时间3分钟",
        background: "rgba(0, 0, 0, 0)",
        customClass: "loadinger",
      });

      if (this.startTimer.status == 0) {
        //记录当前时间戳
        this.startTimer.status = Date.now();
      }
      //比对时间
      let current = Date.now();
      if (current - this.startTimer.status >= 1200000) {
        this.$alert("生成超时，请重新生成", "错误", {
          confirmButtonText: "确定",
        });
        this.startTimer.status = 0;
        this.thumburl = "";
        this.qrcode = "";
        clearTimeout(this.timer2);
        clearTimeout(this.timer);
        loadingIns.close();
        return;
      }
      if (that.timer != null) await clearTimeout(that.timer);

      instance
        .post("/api/taskstatus", {
          orderid,
        })
        .then(async (res) => {
          if (res.data.status != 1) {
            if (res.data.error != 0) {
              loadingIns.close();
              that.$alert(res.data.msg, "错误", {
                confirmButtonText: "确定",
              });
            } else {
              that.timer = setTimeout(async () => {
                await that.getStatus(orderid);
              }, 5000);
            }
          } else {
            loadingIns.close();
            that.thumburl = res.data.thumburl;
            that.thumburl3D = res.data['3dthumburl']
            let img = new Image()
            img.src = res.data.base64
            img.onload = function() {
              //降低精度
              let canvas = document.createElement('canvas');
              let ctx = canvas.getContext('2d');
              const scaleFactor = 0.5; // 降低到原始尺寸的50%
              canvas.width = img.width * scaleFactor;
              canvas.height = img.height * scaleFactor;
              ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
              that.base64 = canvas.toDataURL('image/png'); // 将结果转换为DataURL

              // let width = img.width
              // let height = img.height
              // that.picWidth = window.innerWidth /10
              // that.picHeight = that.picWidth*(height/width)
              // 将图像绘制到画布上
              // ctx.drawImage(img,0,0,picWidth,picWidth*(height/width))
              
              // 在这里可以进行其他操作，如对图像进行处理、保存等
              that.getQrcode(orderid);
            };



          }
          // console.log()
          // console.log(res.data)
        });
    },
    createTask() {
      let that = this;
      if (this.textarea == "") {
        this.$alert(`请输入提示词`, "错误", {
          dangerouslyUseHTMLString: true,
        });
        return;
      }
      if (this.url == "") {
        this.$alert(`请上传图片`, "错误", {
          dangerouslyUseHTMLString: true,
        });
        return;
      }
       let textCheck = this.text_source.includes('当前图像中有大量空白区域，建议裁剪后再出图，否则严重影响出图效果')
       this.dialogVisible = textCheck
       if(!textCheck) this.subCreate()
     
    },
    handlePictureCardPreview(file, index) {
      // let checkIndex = index == 0 ? 1 : 0
      // //判断是否已经上传
      // if(this.uploader[checkIndex].dialogImageUrl == ''){
      //   console.log(index,checkIndex)
      //   this.uploader[index].dialogImageUrl = file.url;
      //   this.uploader[index].dialogVisible = true;
      // }else{
      //   this.$alert(`您已经上传${index == 0 ?'线稿图':'写实图'},请修改图片或者清除原图片修改上传类型`, '错误', {
      //     dangerouslyUseHTMLString: true
      //   });
      // }
    },
    handleDownload(file) {
      console.log(file);
    },
  },
};
</script>

<style>
.loadinger {
  font-size: 0.8rem;
  font-weight: bold;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
.flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.gray-container {
  background: #f6f6f6;
  padding: 1.5vw;
}
.desc {
  color: #8d8b8b;
}
.h {
  color: #332c2b;
}
.title {
  font-size: 1.2vw;
}
.sec-tit {
  font-size: 0.8vw;
  margin: 12px 0;
}
.tag {
  padding: 8px 12px;
  border-radius: 6px;
  border: solid #e60112 1px;
  background: #ffe5e7;
  color: #e70c1c;
  font-size: 1.2vw;
  display: inline-block;
  text-align: center;
}

.el-button--primary {
  background-color: #332d2b !important; /* 修改背景颜色 */
  border-color: #332d2b!important; /* 修改边框颜色 */
  color: #ffffff !important; /* 修改文字颜色 */
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: #948581 !important; /* 修改hover和focus状态下的背景颜色 */
  border-color: #948581 !important; /* 修改hover和focus状态下的边框颜色 */
  color: #ffffff !important; /* 修改hover和focus状态下的文字颜色 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue